module.exports = __webpack_public_path__ + "img/icon_img.b7de0a49.png";